module.exports = __webpack_public_path__ + "img/gb9113_14_b.prt.03621118.jpg";